<template>
  <div class="container mt-8 lg:mt-12">
    <hr class="text-[#9E9E9E]" />
  </div>
</template>
